//client\src\hooks\useChatList.js

import { useState, useCallback, useEffect } from 'react';
import { authFetch } from '../Utilities/Api';

export default function useChatList(userId) {
    const [serverChats, setServerChats] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchChats = useCallback(async () => {
        if (!userId) return;

        setIsLoading(true);
        try {
            // ✅ Correct path (assuming authFetch adds /api)
            const res = await authFetch('/chats');
            if (!res.ok) throw new Error('Failed to fetch chats');

            const data = await res.json();

            // ✅ Normalize data so components can use 'participants' or 'members'
            const cleaned = Array.isArray(data)
                ? data
                    .filter((c) => c && c._id)
                    .map((chat) => ({
                        ...chat,
                        // Ensure 'participants' exists for UI compatibility
                        participants: chat.participants || chat.members || [],
                        // Ensure 'isGroup' boolean exists for logic compatibility
                        isGroup: chat.type === 'GROUP',
                    }))
                : [];

            setServerChats(cleaned);
        } catch (err) {
            console.error("❌ [useChatList] Error:", err);
        } finally {
            setIsLoading(false);
        }
    }, [userId]);

    // NEW: Automatically fetch when userId changes
    useEffect(() => {
        if (userId) {
            fetchChats();
        }
    }, [userId, fetchChats]);

    return {
        serverChats,
        setServerChats,
        fetchChats,
        isLoading
    };
}